/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebstepphotos3Inputs */

const en_placewebstepphotos3 = /** @type {(inputs: Placewebstepphotos3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Picking photos`)
};

const de_placewebstepphotos3 = /** @type {(inputs: Placewebstepphotos3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotos auswählen`)
};

/**
* | output |
* | --- |
* | "Picking photos" |
*
* @param {Placewebstepphotos3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebstepphotos3 = /** @type {((inputs?: Placewebstepphotos3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebstepphotos3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebstepphotos3(inputs)
	return de_placewebstepphotos3(inputs)
});
export { placewebstepphotos3 as "placeWebStepPhotos" }